import React from 'react';
import { useDispatch } from 'src/state/redux';
import { StyleSheet } from 'react-native';
import { exportData } from './Export';
import { useCurrentUser, useUsersByTenantId } from 'src/state/redux/selector/user';
import { DRAWER_ENTITIES, drawerActions } from 'src/state/redux/slice/drawer';
import DNAUsersList from 'src/components/DNA/Users/DNAUsersList';
import { DNABox, DNAButton, luxColors } from '@alucio/lux-ui';
import { useTenant } from 'src/state/redux/selector/tenant';

const styles = StyleSheet.create({
  crumbsColor: {
    color: luxColors.flat.primary,
  },
  header: {
    marginBottom: 16,
  },
  itemTextColor: {
    color: luxColors.contentText.tertiary,
  },
  mainWrapper: {
    backgroundColor: luxColors.emptyStateButtonText.primary,
    overflowX: 'auto',
  },
  tab: {
    paddingHorizontal: 12,
    paddingVertical: 20,
  },
  tenantRowWrapper: {
    borderBottomColor: luxColors.divider.primary,
    borderBottomWidth: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 20,
  },
  tenantsWrapper: {
    borderRadius: 4,
    overflow: 'hidden',
  },
  actionsContainer: {
    padding: 16,
  },
});

// Component for user actions (export and add user buttons)
export const UserActions = (props: { tenantId: string }) => {
  const currentUser = useCurrentUser();
  const dispatch = useDispatch();
  const tenantUsers = useUsersByTenantId(props.tenantId);
  const tenant = useTenant(props.tenantId);

  function openCreateUserModal(): void {
    dispatch(drawerActions.toggle({
      entity: DRAWER_ENTITIES.USER,
      tenantId: props.tenantId,
    }));
  }

  return (
    <DNABox spacing="sm" alignX="end" style={styles.actionsContainer}>
      <DNAButton
        appearance="outline"
        status="primary"
        iconLeft="download-simple"
        onPress={() => exportData(tenantUsers, currentUser, tenant)}
        children="Export users list"
      />
      <DNAButton
        onPress={openCreateUserModal}
        children="Add user"
      />
    </DNABox>
  );
};

UserActions.displayName = 'UserActions';

// Component for displaying the users list
export const UsersList = (props: { tenantId: string }) => {
  const tenantUsers = useUsersByTenantId(props.tenantId);

  return (
    <DNABox style={styles.mainWrapper} fill appearance="col">
      <DNAUsersList usersORM={tenantUsers} />
    </DNABox>
  );
};

UsersList.displayName = 'UsersList';

export default UsersList;
